import Crud from '../views/Grupo/Crud'
import Entity from '../views/Grupo/Add'

let routes = {
    path: '/grupos',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/grupos/add',
            name: 'NewGrupo',
            component: Entity,
            meta: {
                pageTitle: 'Adicionar Grupo',
                breadcrumb: [
                    {
                        text: 'Grupos',
                        to: '/grupos',
                        active: false,
                    },
                    {
                        text: 'Criar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/grupos/edit/:id?',
            name: 'EditGrupo',
            component: Entity,
            meta: {
                pageTitle: 'Editar Grupo',
                breadcrumb: [
                    {
                        text: 'Grupos',
                        to: '/grupos',
                        active: false,
                    },
                    {
                        text: 'Editar',
                        active: true,
                    }
                ],
            },
        },
        {
            path: '/grupos',
            name: 'list-grupos',
            component: Crud,
            meta: {
                pageTitle: 'Lista de Grupos',
                breadcrumb: [
                    {
                        text: 'Grupos',
                        active: true,
                    },
                ],
            },
        },
    ]
};


export default routes
